import * as React from 'react'
import { Column } from '../../components/Common/Flex'
import { PageContent } from '../../components/Common/PageContent'
import { RouteComponentProps } from 'react-router'
import { USER_STORE } from '../../stores'
import { inject } from 'mobx-react'
import { UserStore } from '../../stores/UserModel'
import { ADD_PHOTOS_STORE, AddPhotosStore } from '../../stores/AddPhotosStore'
import { LogoutButton } from '../../components/LogoutButton'
import { ConfirmModal } from '../../components/ConfirmModal'
import { LogoutConfirmModal } from '../../components/LogoutConfirmModal'
import { PasskeysSection } from './PasskeysSection'

interface ProfilPageProps extends RouteComponentProps {
  [USER_STORE]: UserStore
  [ADD_PHOTOS_STORE]: AddPhotosStore
}

export const ProfilePage = (props: ProfilPageProps) => {
  const [logoutConfirmOpen, setLogoutConfirmOpen] = React.useState(false)
  const [uploadWarningOpen, setUploadWarningOpen] = React.useState(false)

  const handleLogoutClick = () => {
    if (props[ADD_PHOTOS_STORE].isUploading) {
      setUploadWarningOpen(true)
      return
    }
    setLogoutConfirmOpen(true)
  }

  const handleConfirmLogout = () => {
    setLogoutConfirmOpen(false)
    props[USER_STORE].logout()
    props.history.push('/login')
  }

  return (
    <PageContent maxWidth="max-w-xl">
      <Column>
        <PasskeysSection />
        <LogoutButton onClick={handleLogoutClick} className="mt-6" />

        <LogoutConfirmModal
          isOpen={logoutConfirmOpen}
          onClose={() => setLogoutConfirmOpen(false)}
          onConfirm={handleConfirmLogout}
        />

        <ConfirmModal
          isOpen={uploadWarningOpen}
          onClose={() => setUploadWarningOpen(false)}
          onConfirm={() => setUploadWarningOpen(false)}
          title="Przed wylogowaniem"
          description="Upewnij się, że żadne zdjęcia nie są aktualnie wysyłane."
          confirmLabel="Ok"
          variant="warning"
          hideCancel
        />
      </Column>
    </PageContent>
  )
}

export default inject(ADD_PHOTOS_STORE)(inject(USER_STORE)(ProfilePage))
